import React from "react";
import { SectionShell, Field } from "./PartnerFormPrimitives";
import { AVAILABILITY_OPTIONS, START_TIMEFRAMES } from "./partnerConstants";

export default function PartnerAvailability({ data, set }) {
  return (
    <SectionShell
      index={6}
      title="Availability & Scheduling"
      subtitle="When you can start."
      testId="partner-section-availability"
    >
      <div className="grid sm:grid-cols-2 gap-3">
        <Field label="Current Availability" required>
          <select className="select-br" value={data.current_availability} onChange={set("current_availability")} required>
            <option value="">Please select</option>
            {AVAILABILITY_OPTIONS.map((a) => <option key={a} value={a}>{a}</option>)}
          </select>
        </Field>
        <Field label="Preferred Start Timeframe" required>
          <select className="select-br" value={data.preferred_start} onChange={set("preferred_start")} required>
            <option value="">Please select</option>
            {START_TIMEFRAMES.map((a) => <option key={a} value={a}>{a}</option>)}
          </select>
        </Field>
      </div>
      <Field label="Scheduling Constraints or Blackout Periods">
        <textarea rows={2} className="textarea-br" value={data.scheduling_constraints} onChange={set("scheduling_constraints")} placeholder="e.g. closed week of July 4" />
      </Field>
    </SectionShell>
  );
}
